<template>
  <v-app class="app-main">
    <div class="container-autor">
      <header-author :data="author" @updated="findProjectsProfile" />
      <div class="mx-8 projects-grid" v-if="author.projects?.length">
        <title-session-component title="Obras Publicadas" tag="h1" />
        <div class="projects-wrapper mt-4">
          <a
            v-for="project in author.projects"
            :key="project.id"
            :href="projectPath(project)"
            :aria-label="`Abrir obra ${project.name}`"
            class="project-card"
          >
            <img :src="project.project_thumb" :alt="project.name" class="project-image" />
          </a>
        </div>
      </div>
    </div>

    <div class="mx-8 mt-8">
      <CarouselSection v-if="author?.latest_updateds.length" type="last-updated" title="Últimos Atualizados"
        :items="author?.latest_updateds" :has-background-image="true" />
    </div>
    <div class="banner-container" v-if="banner.image" @click="goToLink" style="cursor: pointer;">
      <img :src="banner.image" :alt="banner.title" class="banner-img" />
    </div>

  </v-app>
</template>

<script>
import CarouselSection from '@/components/CarouselSection.vue';
import HeaderAuthor from '@/components/HeaderAuthor.vue';
import TitleSessionComponent from '@/components/TitleSessionComponent.vue';
import Banner from '@/models/Banner';
import BannerService from '@/server/BannerService';
import { detailsAuthor } from '@/server/userServe';
import { projectPath } from '@/utils/projectRoutes';

export default {
  name: 'AuthorView',
  components: {
    HeaderAuthor,
    CarouselSection,
    TitleSessionComponent
  },
  data() {
    return {
      authorId: null,
      author: {
        author: {
          description: ''
        },
        projects: [],
        latest_updateds: []
      },
      banner: new Banner(), // <- banner único que será exibido
      banners: [], // <- lista que vem da API
      service: new BannerService(),
    };
  },
  mounted() {
    this.list();
  },

  methods: {
    goToLink() {
      if (this.banner.link) {
        window.open(this.banner.link, '_blank');
      }
    },
    projectPath,
    async list() {
      try {
        const response = await this.service.list(); // pega todos os banners
        this.banners = response;

        // Sorteia um banner da lista
        if (this.banners.length > 0) {
          const randomIndex = Math.floor(Math.random() * this.banners.length);
          this.banner = this.banners[randomIndex];
        }
      } catch (err) {
        console.error('Erro ao listar banners:', err);
      }
    },
    async findProjectsProfile() {
      try {
        this.authorId = this.$route.params.authorId;
        this.author = await detailsAuthor(this.authorId);
      } catch (error) {
        console.error("Erro ao buscar os dados do autor:", error);
      }
    },
  },

  watch: {
    '$route.params.authorId': {
      immediate: true,
      handler() {
        this.findProjectsProfile();
      }
    }
  }
};
</script>

<style scoped>

.banner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto;
}
.banner-img {
  width: 80%;
  height: auto;
  margin: 0 auto;
}
.container-autor {
  display: flex;
}

.app-main {
  width: 80%;
  margin: 0 auto;
}

.projects-grid {
  width: 100%;
  overflow: hidden;
}

.projects-wrapper {
  display: grid;
  gap: 14px;
}

/* Definição base dos cards */
.project-card {
  display: block;
  width: 100%;
  max-width: 250px !important;
  aspect-ratio: 2 / 3;
  /* Mantém a proporção do card */
  background-color: #222;
  border-radius: 8px;
  overflow: hidden;
  text-align: center;
  transition: transform 0.2s;
  color: inherit;
  text-decoration: none;
}

.project-card:hover {
  transform: scale(1.05);
}

/* A imagem ocupa 100% do card */
.project-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Responsividade */
@media (max-width: 780px) {
  .app-main {
    width: 100% !important;
    margin: 0 auto;
  }

  .container-autor {
    display: block;
  }

  .projects-wrapper {
    grid-template-columns: repeat(3, 1fr);
    /* Agora mostra 3 colunas no mobile */
    gap: 8px;
    /* Reduz o espaçamento entre os cards */
  }

  .project-card {
    max-width: 80px;
    /* Define um tamanho menor para os cards */
    aspect-ratio: 2 / 3;
  }
}

@media (max-width: 480px) {
  .projects-wrapper {
    grid-template-columns: repeat(2, 1fr);
    /* Mostra 4 colunas em telas menores */
    gap: 6px;
  }
  .v-application .mx-8 {
    margin-right: 32px !important;
    margin-left: 7px !important;
}

  .project-card {
    max-width: 150px;
    /* Tamanho ainda menor para telas muito pequenas */
  }
}


@media (min-width: 730px) and (max-width: 1024px) {
  .projects-wrapper {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1024px) and (max-width: 1400px) {
  .projects-wrapper {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 1400px) {
  .projects-wrapper {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (min-width: 1800px) {
  .projects-wrapper {
    grid-template-columns: repeat(6, 1fr);
  }
}
</style>
